<template>
  <Transition
    :name="name"
  >
    <VRow
      v-show="innerDisplay"
      no-gutters
      :class="{
        'fill-width': fillWidth,
        [fullHeight ? 'overlay-height-full' : 'overlay-height-viewport']: fullHeight || fillHeight,
        'background': background,
        'pink': pink,
        'overlay-right': overlayRight,
        'overlay-left': !overlayRight
      }"
      data-testid="layout"
      class="overlay-top"
    >
      <SBtn
        v-if="isClosable"
        icon
        class="menu-close py-2"
        max-height="36"
        max-width="36"
        data-testid="button"
        @click="innerDisplay=false"
      >
        <VIcon color="white">
          {{ icons.mdiClose }}
        </VIcon>
      </SBtn>
      <slot />
    </VRow>
  </Transition>
</template>

<script setup lang="ts">
import { mdiClose } from '@mdi/js'

interface Props {
  display?: boolean
  isClosable?: boolean
  fillWidth?: boolean
  fillHeight?: boolean
  fullHeight?: boolean
  background?: boolean
  overlayRight?: boolean
  pink?: boolean
  name?: string
}

const icons = { mdiClose }

const props = withDefaults(defineProps<Props>(), {
  display: false,
  isClosable: false,
  fillWidth: false,
  fillHeight: false,
  fullHeight: false,
  background: false,
  overlayRight: true,
  pink: false,
  name: 'slide-y'
})

const emits = defineEmits<{
  (e: 'update:display', val: boolean): void
}>()

const innerDisplay = ref(false)

watch(() => props.display, (newVal) => {
  innerDisplay.value = newVal
}, { immediate: true })

watch(innerDisplay, (val) => {
  emits('update:display', val)
})
</script>

<style lang="scss" scoped>
  .slide-x-leave-active,
  .slide-x-enter-active {
    transition: .3s;
  }
  .slide-x-enter {
    transform: translate(100%, 0);
  }
  .slide-x-leave-to {
    transform: translate(100%, 0);
  }
  .slide-y-leave-active,
  .slide-y-enter-active {
    transition: .3s;
  }
  .slide-y-enter {
    transform: translate(0, -100%);
  }
  .slide-y-leave-to {
    transform: translate(0, -100%);
  }
  .menu-close {
    position: absolute;
    top: 4px;
    right: 12px;
    z-index: 301;
  }
  .overlay-top {
    top: 0;
    position: absolute;
    justify-content: end;
  }
  .overlay-right {
    right: 0;
  }
  .overlay-left {
    left: 0;
  }
  .fill-width {
    width: 100%;
  }
  .overlay-height-viewport {
    height: 100vh;
  }
  .overlay-height-full {
    height: 100%;
  }
  .background {
    background: rgba(51,51,51, .85);
  }
  .slide-x-left-leave-active,
  .slide-x-left-enter-active {
    transition: .5s;
  }
  .slide-x-left-enter {
    opacity: 0;
    transform: translate(-100%, 0);
  }
  .slide-x-left-leave-to {
    opacity: 0;
    transform: translate(-100%, 0);
  }
  .highlight-demo-leave-active,
  .highlight-demo-enter-active {
    transition: .5s;
  }
  .highlight-demo-enter {
    opacity: 0;
    transform: translate(-50%, 0) scaleX(0);
  }
  .highlight-demo-leave-to {
    opacity: 0;
    transform: translate(50%, 0) scaleX(0);
  }
  .pink {
    background: rgb(var(--v-theme-secondary));
  }
</style>
